import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Container } from "reactstrap";

import employerBg from "assets/img/homepage/employer/employer_bg.png";

import { ThemeContext } from "../../context/ThemeContext";

import VerticalListDisplay from "./VerticalListDisplay";
import VerticalListDropdown from "../../verticals/components/VerticalListDropdown";
import RecentJobs from "../../verticals/components/RecentJobs";
import RecentCandidates from "../../verticals/components/RecentCandidates";

const CandidateEmployerLink = () => {
    return (
        <Link to="/employers?register=y"><b>get candidates</b></Link>
    )
}

export const JobEmployerLink = () => {
    return (
        <Link to="/employers?register=y"><b>post your job</b></Link>
    )
}

class EmployerMain extends Component {


    render() {

        return (
            <section className={"upward_main upward_employer_main upward_employer_main_" + this.context} style={{ "backgroundImage": `url(${employerBg})` }}>
                <Container className="position-relative" style={{ "minHeight": "100%" }}>
                    <div className="upward_main_details">
                        <h2>120+ million workers are ready to work with you.</h2>
                        <Row>
                            <Col xs="6" lg="4">
                                <a href="https://hire.jobcase.com/purchase/post-now" className="btn btn-xl btn-block btn-dark-orange btn-rounded"> Post a job </a>
                            </Col>
                        </Row>
                    </div>
                    <div className="d-none d-lg-block">
                        <VerticalListDisplay></VerticalListDisplay>
                    </div>

                    {/*<RecentCandidates maxCount={1} linkComponent={CandidateEmployerLink}></RecentCandidates>*/}
                    {/*<RecentJobs maxCount={1} linkComponent={JobEmployerLink}></RecentJobs>*/}
                    <div className="my-6 pb-6 text-center d-md-block d-lg-none">
                        <VerticalListDropdown />
                    </div>
                </Container>
            </section>
        )
    }

}

EmployerMain.contextType = ThemeContext;

export default EmployerMain;